import axios from "axios";
import broker_status from "@/constants/broker_status";

const broker_index = {
  namespaced: true,
  state() {
    return {
      search_conditions: {
        name: null,
        name_kana: null,
        office: null,
        department: null,
        is_supervisor: null,
        status: broker_status.enabled,
      },
      paginationStatus: {
        from: null,
        to: null,
        total: null,
        current_page: null,
        last_page: null,
        per_page: null,
      },
      sortStatus: {
        column: null,
        ascending: true,
      },
      brokers: [],
      errors: {},
    }
  },

  getters: {
    includeFreezeCondition(state) {
      return state.search_conditions.status !== broker_status.enabled;
    },
    getParameter(state) {
      return {
        ...state.search_conditions,
        sort_attribute: state.sortStatus.column,
        sort_direction: state.sortStatus.ascending ? 'asc' : 'desc',
        page: state.paginationStatus.current_page,
        per_page: state.paginationStatus.per_page,
      };
    },
  },

  mutations: {
    includeFreezeCondition(state, payload) {
      if (payload.value) {
        state.search_conditions.status = null;
      } else {
        state.search_conditions.status = broker_status.enabled;
      }
    },
    setData(state, data) {
      state.brokers = data;
      state.errors = {};
    },
    setErrors(state, errors) {
      state.errors = {...errors};
    },
    inputSearchItem(state, payload) {
      if (state.search_conditions[payload.column] !== undefined) {
        state.search_conditions[payload.column] = payload.value;
      }
    },
    resetForms(state) {
      Object.keys(state.search_conditions).forEach((key) => {
        state.search_conditions[key] = null
      })
    },
    setSortColumn(state, payload) {
      if (state.sortStatus.column === payload.column) {
        state.sortStatus.ascending = !state.sortStatus.ascending;
      } else {
        state.sortStatus.column = payload.column;
        state.sortStatus.ascending = true;
      }
      state.paginationStatus.current_page = 1;
    },
    setMeta(state, meta) {
      state.paginationStatus = {
        from: meta.from,
        to: meta.to,
        total: meta.total,
        current_page: meta.current_page,
        last_page: meta.last_page,
        per_page: meta.per_page,
      };
    },
    setCurrentPage(state, payload) {
      state.paginationStatus.current_page = payload.value;
    },
    setPerPage(state, payload) {
      state.paginationStatus.per_page = payload.value;
    },
  },

  actions: {
    load({commit, getters}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/brokers', {params: getters.getParameter}).then((response) => {
          commit('setData', response.data.data);
          commit('setMeta', response.data.meta);
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({handled});
        });
      })
    }
  }
}

export default broker_index
